import React from "react";
import "./PageLayout.css";

/**
 * Shared layout for dashboard child pages: title, optional breadcrumb, content area.
 */
const PageLayout = ({ title, breadcrumb, children }) => {
  return (
    <main className="dashboard-main">
      <div className="page-header">
        {breadcrumb && (
          <nav className="page-breadcrumb" aria-label="Breadcrumb">
            {breadcrumb}
          </nav>
        )}
        <h1 className="page-title">{title}</h1>
      </div>
      <div className="page-content">{children}</div>
    </main>
  );
};

export default PageLayout;
